var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkweek(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_13306",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_21",
    fill: "#414141",
    d: "M35,44H10c-3.9,0-7.1-3.2-7.1-7.1v-25C2.9,8,6.1,4.8,10,4.8h1.2v5.1 c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6V4.8h15.2v5.1c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6V4.8H35 c3.9,0,7.1,3.2,7.1,7.1v25C42.1,40.9,38.9,44,35,44L35,44z M10.7,13.4c-2.9,0-5.3,2.4-5.3,5.3v17.6c0,2.9,2.4,5.3,5.3,5.3h23.7 c2.9,0,5.3-2.4,5.3-5.3V18.7c0-2.9-2.4-5.3-5.3-5.3L10.7,13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9709",
    fill: "#414141",
    d: "M12.8,11.2c-0.7,0-1.2-0.5-1.2-1.2l0,0V2.2c0-0.7,0.5-1.2,1.2-1.2c0,0,0,0,0,0 C13.5,1,14,1.5,14,2.2l0,0V10C14,10.6,13.5,11.2,12.8,11.2L12.8,11.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9710",
    fill: "#414141",
    d: "M31.2,11.2c-0.7,0-1.2-0.5-1.2-1.2l0,0V2.2C30,1.5,30.5,1,31.2,1c0,0,0,0,0,0 c0.7,0,1.2,0.5,1.2,1.2l0,0V10C32.4,10.6,31.9,11.2,31.2,11.2L31.2,11.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_25",
    fill: "#414141",
    d: "M11.7,37.9c-2,0-3.5-1.6-3.5-3.5V20.1c0-2,1.6-3.5,3.5-3.5s3.5,1.6,3.5,3.5v14.2 C15.3,36.3,13.7,37.9,11.7,37.9z M11.7,18.7c-1.2,0-2.3,1-2.3,2.3v12.6c0,1.2,1,2.3,2.3,2.3s2.3-1,2.3-2.3V20.9 C14,19.7,13,18.7,11.7,18.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4528",
    fill: "#414141",
    d: "M22.4,16.6L22.4,16.6c2,0,3.5,1.6,3.5,3.5v14.2c0,2-1.6,3.5-3.5,3.5l0,0 c-2,0-3.5-1.6-3.5-3.5V20.1C18.8,18.2,20.4,16.6,22.4,16.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4530",
    fill: "#414141",
    d: "M33,16.6L33,16.6c2,0,3.5,1.6,3.5,3.5v14.2c0,2-1.6,3.5-3.5,3.5l0,0 c-2,0-3.5-1.6-3.5-3.5V20.1C29.5,18.2,31.1,16.6,33,16.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkweek);
export default __webpack_public_path__ + "static/media/work week.d50035626a25e440659dbbcd1363ed2c.svg";
export { ForwardRef as ReactComponent };